<template>
  <div>
    <div class="instructor-edit-form setting-cell">
      <div
        v-if="page == 'setting'"
        class="instructor-setting-header"
      >
	  	<div class="instructor-setting-header__left">
			강사 리스트
		<popover>
			강사 이메일 계정과 최초 비밀번호<strong class="el-popover__emphasis-text">(센터코드, 소문자)</strong><br>
			로 로그인 시 관리자가 설정한 접근 권한에<br>
			맞게 피플박스를 이용할 수 있습니다. <br>
		</popover>
		</div>
		<div class="instructor-setting-header__right">
			<button @click="handleClickMoveRolePage"> 
			<img src="image/icon/lock.svg"/>
			권한 설정
			</button>
		</div>
      </div>
	  <div class="form-divide-line" />
      <template v-if="showNoInstructor">
        <div class="empty-message">
          <div>
            <warning-message message="등록된 강사가 없습니다." />
            <el-button
              class="black"
              @click="handleClickFirstAdd"
            >
              강사 추가
            </el-button>
          </div>
        </div>
      </template>

      <template v-else>
        <instructor-inline-form
          v-for="(data, index) in datas"
          :key="data.id"
          :mode="data.mode"
          :data="data"
          @changeMode="handleChangeMode"
          @update="handleUpdateForm"
          @delete="handleDeleteForm"
        />
        <template v-if="isCreating">
          <instructor-inline-form
            :mode="INLINE_FORM_MODE.FORM"
            @create="handleCreateForm"
            @changeMode="handleChangeMode"
          />
        </template>
      </template>
    </div>
    <div
      v-if="!showNoInstructor && !isCreating"
      class="controller-area"
    >
      <el-button
        class="black float-md-left float-right"
        @click="handleClickAdd"
      >
        강사 추가
      </el-button>
    </div>
  </div>
</template>

<script>
import InstructorInlineForm from "./InstructorInlineForm";
import { INLINE_FORM_MODE } from "@/constants";
import Popover  from "@/components/popover";
import WarningMessage from "@/components/element-ui/WarningMessage";
import { fiflboxApi } from '@/utils/api';

export default {
	name: "InstructorEditForm",
	components: {
		WarningMessage,
		InstructorInlineForm,
		Popover
	},
	props: ["page"],
	data() {
		return {
			INLINE_FORM_MODE,
			datas: [],
			showNoInstructor: false,
			isCreating: false,
			center: {},
		};
	},
	computed: {
		isNextButtonDisabled() {
			return this.datas.length === 0;
		},
	},
	async mounted() {
		await this.syncFormDatas();

		let { data: center } = await fiflboxApi.v1.getAccountsCenter();
		delete center.user.email;
		this.center = center;
	},
	methods: {
		async syncFormDatas() {
			try {
        let { data: datas } = await fiflboxApi.v2.getCenterInstructors();

				this.datas = datas.filter(data => !data.is_removed).map(data => {
					return {
						mode: INLINE_FORM_MODE.VIEW,
						...data,
					};
				});

				if (this.datas.length === 0) {
					this.showNoInstructor = true;
				}
			} catch (err) {}
		},
		async handleCreateForm(form) {
			try {
        await fiflboxApi.v2.postCenterInstructors(form);
				await this.syncFormDatas();
				this.isCreating = false;
				this.$message({
					type: "success",
					message: "강사가 추가됐습니다.",
				});
			} catch (err) {
				// console.log(err.response.data)
			}
		},
		async handleUpdateForm(form) {
			try {
        		await fiflboxApi.v2.putCenterInstructors(form.id, form);
				await this.syncFormDatas();
				this.$message({
					type: "success",
					message: "강사가 수정됐습니다.",
				});
			} catch (err) {
					// console.log(err.response.data)
				}
		},
		async handleDeleteForm(form) {
			try {
				await this.$confirm(
					"이미 해당 강사가 배정된 수업 내역에서는 삭제되지 않습니다. 개별적으로 수정해주시길 바랍니다.",
					"강사 삭제",
					{
						confirmButtonText: "확인",
						cancelButtonText: "취소",
						showClose: false,
						customClass: "fifl-message-box",
						confirmButtonClass: "gray",
						cancelButtonClass: "white",
						closeOnPressEscape: false,
					}
				);
			} catch (err) {
				return;
			}

			try {
        await fiflboxApi.v1.deleteCenterInstructors(form.id, form);
				await this.syncFormDatas();
			} catch (err) {}

			this.$message({
				type: "success",
				message: "강사가 삭제됐습니다.",
			});
		},
		handleChangeMode(_data) {
			if (_data.id === null) {
				this.isCreating = false;

				if (this.datas.length === 0) {
					this.showNoInstructor = true;
				}
			}

			const target = this.datas.find(data => data.id === _data.id)
			if(target){
				target.mode = _data.mode;
			}
		},
		handleClickFirstAdd() {
			this.showNoInstructor = false;
			this.isCreating = true;
		},
		handleClickAdd() {
			this.isCreating = true;
		},
		handleClickMoveRolePage(){
			this.$router.push('/setting/instructor/role').catch(()=>{})
		}
	},
};
</script>

<style lang="scss">
.el-popover__emphasis-text{
	font-size: 12px;
	font-weight: normal;
	letter-spacing: -0.69px;
}

.setting-cell {
	border-radius: 6px;
	background-color: #ffffff;
	box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);
	padding: 20px;
	margin-bottom: 15px;
}

.instructor-edit-form {
	.instructor-setting-header {
		display: flex;
		justify-content: space-between;
		font-size: 14px;
		font-weight: 500;
		font-style: normal;
		font-stretch: normal;
		line-height: 1.43;
		letter-spacing: -0.6px;
		.instructor-setting-header__right{
			img{
				width: 20px;
				height: 20px;
			}
			button{
				border: none;
				background-color: inherit;
			}
		}
	}
	.form-divide-line {
		margin : 7px auto;
	}

	.empty-message {
		min-height: 388px;

		& > div {
			text-align: center;

			.warning-message-container {
				margin-bottom: 30px;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.empty-message {
			min-height: 300px;
		}
	}
}

.controller-area {
	padding: 10px 20px;
}
</style>
